var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLoginWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLoginWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLoginWhite",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0 C4.3292398,0 2.4011149,1.0674501 1.2207031,2.7070312 C1.20616266,2.72687534 1.19310638,2.7477654 1.1816406,2.7695312 C0.9115085,3.1564749 0.6981604,3.57148 0.5195312,4 L1.6015625,4 C1.7265625,3.755 1.8702031,3.5189688 2.0332031,3.2929688 L2.03125,3.2929688 C3.0308382,1.9045499 4.6567602,1 6.5,1 C9.543833,1 12,3.456167 12,6.5 C12,9.543833 9.543833,12 6.5,12 C4.7082346,12 3.1222551,11.14658 2.1171875,9.824219 C1.9191875,9.563219 1.7514687,9.286 1.6054688,9 L0.5195312,9 C0.7185698,9.474849 0.9620461,9.933457 1.2734375,10.357422 C1.28553076,10.3792495 1.29924093,10.4001412 1.3144531,10.419922 C1.31638076,10.422545 1.31833399,10.4251491 1.3203125,10.427734 C1.3208689,10.428466 1.3217089,10.428956 1.3222656,10.429688 C2.5092934,11.990079 4.3907546,13 6.5,13 C10.084167,13 13,10.084167 13,6.5 C13,2.915833 10.084167,0 6.5,0 Z M7,4 L7,6 L0,6 L0,7 L7,7 L7,9 L9.5,6.5 L7,4 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoginWhite);
export default __webpack_public_path__ + "static/media/icLoginWhite.4c5473bf2f6bcba30eafc169a0328991.svg";
export { ForwardRef as ReactComponent };